import { xEnsureFloat64, xyEquallySpaced } from 'ml-spectra-processing';
export const id = 'equallySpaced';
export const name = 'Equally spaced';
export const DOMAIN_UPDATE_RULES = {
    updateXDomain: false,
    updateYDomain: false,
};
/**
 * Equally Spaced
 * **
 * Function that returns a Number array of equally spaced numberOfPoints
 * containing a representation of intensities of the spectra arguments x
 * and y.
 *
 * The options parameter contains an object in the following form:
 * from: starting point
 * to: last point
 * numberOfPoints: number of points between from and to
 * variant: "slot" or "smooth" - smooth is the default option
 *
 * The slot variant consist that each point in the new array is calculated
 * averaging the existing points between the slot that belongs to the current
 * value. The smooth variant is the same but takes the integral of the range
 * of the slot and divide by the step size between two points in the new array.
 *
 * @param {Array<{from:number;to:number}>} options.exclusions
 */
export function apply(spectrum, options = {}) {
    if (!isApplicable(spectrum)) {
        throw new Error('Equally Spaced is not applicable on this data');
    }
    const { from, to, numberOfPoints, exclusions } = options;
    const { x, re, im } = spectrum.data;
    const XREdata = xyEquallySpaced({ x, y: re }, { from, to, numberOfPoints, exclusions });
    spectrum.data.x = xEnsureFloat64(XREdata.x);
    spectrum.data.re = xEnsureFloat64(XREdata.y);
    if (im) {
        const XIMdata = xyEquallySpaced({ x, y: re }, { from, to, numberOfPoints, exclusions });
        spectrum.data.im = xEnsureFloat64(XIMdata.y);
    }
}
export function isApplicable(spectrum) {
    if (spectrum.info.isComplex && !spectrum.info.isFid)
        return true;
    return false;
}
export function reduce() {
    return {
        once: false,
        reduce: null,
    };
}
//# sourceMappingURL=equallySpaced.js.map